export default __webpack_public_path__ + "static/oeko-tex-madeingreen-4d3c6e8dc0424e0627d6aed68ae02fe0.png";